import { render } from "./menuLink.vue?vue&type=template&id=395d118d&ts=true"
import script from "./menuLink.vue?vue&type=script&lang=ts"
export * from "./menuLink.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__